/**
 * Croatian language pluralization helpers
 */

import { pluralizeCroatian } from '@/utils/functions.utils';

/**
 * Get the correct Croatian plural form for "dan" (day)
 * @param {number} count - The number of days
 * @returns {string} - "dan" or "dana"
 */
export const pluralizeDan = (count) => {
  return pluralizeCroatian(count, 'dan', 'dana', 'dana');
};

/**
 * Get the correct Croatian plural form for "rata" (installment)
 * @param {number} count - The number of installments
 * @returns {string} - "rata", "rate", or "rata"
 */
export const pluralizeRata = (count) => {
  return pluralizeCroatian(count, 'rata', 'rate', 'rata');
};
